<template>
  <div>
    <!-- 省列表 -->
    <el-select
      v-model="province"
      value-key="provinceId"
      @change="handleChangeProvince"
      placeholder="省"
      :class="size + '-size'">
      <el-option
        v-for="province in locations"
        :key="province.provinceId"
        :label="province.provinceName"
        :value="province">
      </el-option>
    </el-select>

    <!-- 市列表 -->
    <el-select
      v-model="city"
      value-key="cityId"
      @change="handleChangeCity"
      placeholder="市"
      :class="size + '-size'">
      <el-option
        v-for="city in province.subLocations"
        :key="city.cityId"
        :label="city.cityName"
        :value="city">
      </el-option>
    </el-select>

    <!-- 区列表 -->
    <!-- <el-select
      v-model="district"
      value-key="districtId"
      @change="handleChangeDistrict"
      placeholder="区"
      :class="size + '-size'">
      <el-option
        v-for="district in city.subLocations"
        :key="district.districtId"
        :label="district.districtName"
        :value="district">
      </el-option>
    </el-select> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Type from '@/utils/type'
import isEmpty from '@/utils/isEmpty'

export default {
  name: 'FwLocation',
  props: {
    value: {
      type: Object,
      default: () => ({
        provinceId: '',
        cityId: '',
        districtId: ''
      })
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  data: () => ({
    province: {
      subLocations: []
    },
    city: {
      subLocations: []
    }
    // district: {}
  }),
  computed: mapState(['locations']),
  watch: {
    value: {
      handler (val, oldVal) {
        this.initLocation()
        if (isEmpty(val)) {
          this.clear()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getAllLocations']),
    initLocation () {
      if (this.locations.length <= 0) {
        // no locations should request before
        this.getAllLocations()
          .then(this.load)
          .catch(this.errorHandler)
      } else {
        this.load()
      }
    },
    isExistSubLocations (location) {
      if (location && location.subLocations) {
        if (Type.isArray(location.subLocations)) {
          return location.subLocations.length > 0
        }
      }
      return false
    },
    load () {
      this.province = this.locations
        .find(obj => (obj.provinceId === this.value.provinceId)) || { subLocations: [] }

      if (this.isExistSubLocations(this.province)) {
        this.city = this.province.subLocations
          .find(obj => (obj.cityId === this.value.cityId)) || { subLocations: [] }
      }

      // if (this.isExistSubLocations(this.city)) {
      //   this.district = this.city.subLocations
      //     .find(obj => (obj.districtId === this.value.districtId))
      // }
    },
    handleChangeCity () {
      // this.district = {}
      this.$emit('change-city', this.city)
      this.$emit('input', this.city)
    },
    handleChangeProvince () {
      this.city = {}
      // this.district = {}
      this.$emit('change-province', this.province)
    },
    // handleChangeDistrict () {
    //   this.$emit('change-district', this.district)
    //   this.$emit('input', this.district)
    // },
    clear () {
      this.province = {}
      this.city = {}
      this.district = {}
    }
  }
}
</script>

<style scoped>
  .mini-size {
    width: 100px;
  }
  .normal-size {
    width: 150px;
  }
  .large-size {
    width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Common/FwLocation.vue